/**
 * Zustand SÓ para preferência de quem está usando: densidade e barra lateral.
 *
 * Estado de servidor é do TanStack Query, filtro é da URL. Se preferência,
 * cache e filtro morarem no mesmo lugar, a primeira coisa que quebra é o
 * botão "voltar" do navegador.
 */

import { DENSIDADE_PADRAO, type ModoDeDensidade } from '@anery/design-system';
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface EstadoDePreferencias {
  densidade: ModoDeDensidade;
  barraLateralAberta: boolean;
  definirDensidade: (densidade: ModoDeDensidade) => void;
  alternarDensidade: () => void;
  alternarBarraLateral: () => void;
}

export const usePreferencias = create<EstadoDePreferencias>()(
  persist(
    (set) => ({
      densidade: DENSIDADE_PADRAO,
      barraLateralAberta: true,
      definirDensidade: (densidade) => {
        set({ densidade });
      },
      alternarDensidade: () => {
        set((atual) => ({ densidade: atual.densidade === 'compacta' ? 'confortavel' : 'compacta' }));
      },
      alternarBarraLateral: () => {
        set((atual) => ({ barraLateralAberta: !atual.barraLateralAberta }));
      },
    }),
    {
      name: 'anery.preferencias',
      // Só preferência é persistida. Nada de dado de caso em localStorage:
      // é máquina compartilhada em operação, e o domínio é home care.
      partialize: (estado) => ({ densidade: estado.densidade, barraLateralAberta: estado.barraLateralAberta }),
    },
  ),
);
